import React from "react";
import { Tag, Skeleton } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import {
  InsightsCard,
  InsightsTitle,
  InsightsGrid,
  InsightItem,
  InsightLabel,
  InsightProgressContainer,
  InsightProgress,
  InsightProgressText,
} from "./styles";
import { DeliveryInsightsProps } from "./types";

const DeliveryInsights: React.FC<DeliveryInsightsProps> = ({ deliveryData }) => {
  const { loading } = useSelector(
    (state: RootState) => state.deliveryCostAnalysis
  );

  if (loading) {
    return (
      <InsightsCard>
        <InsightsTitle>Delivery Insights</InsightsTitle>
        <InsightsGrid>
          {Array.from({ length: 6 }).map((_, index) => (
            <InsightItem key={index}>
              <Skeleton active paragraph={{ rows: 1 }} />
            </InsightItem>
          ))}
        </InsightsGrid>
      </InsightsCard>
    );
  }

  if (!deliveryData?.profitabilityInsights) {
    return null;
  }

  const insights = deliveryData.profitabilityInsights;

  return (
    <InsightsCard>
      <InsightsTitle>Delivery Insights</InsightsTitle>
      <InsightsGrid>
        <InsightItem>
          <InsightLabel>Most Profitable Distance</InsightLabel>
          <Tag color="success">{insights.mostProfitableDistance}</Tag>
        </InsightItem>

        <InsightItem>
          <InsightLabel>Most Profitable Time</InsightLabel>
          <Tag color="processing">{insights.mostProfitableTime}</Tag>
        </InsightItem>

        <InsightItem>
          <InsightLabel>Most Profitable Day</InsightLabel>
          <Tag color="default">{insights.mostProfitableDay}</Tag>
        </InsightItem>

        <InsightItem>
          <InsightLabel>Least Profitable Distance</InsightLabel>
          <Tag color="error">{insights.leastProfitableDistance}</Tag>
        </InsightItem>

        <InsightItem>
          <InsightLabel>Least Profitable Time</InsightLabel>
          <Tag color="warning">{insights.leastProfitableTime}</Tag>
        </InsightItem>

        <InsightItem>
          <InsightLabel>Delivery Efficiency Score</InsightLabel>
          <InsightProgressContainer>
            <InsightProgress
              percent={insights.deliveryEfficiencyScore}
              strokeColor={{
                "0%": "#1890ff",
                "100%": "#52c41a",
              }}
              size="small"
            />
            <InsightProgressText>{insights.deliveryEfficiencyScore}%</InsightProgressText>
          </InsightProgressContainer>
        </InsightItem>
      </InsightsGrid>
    </InsightsCard>
  );
};

export default DeliveryInsights;
